import { useEffect, useState } from 'react'

export const useInitUtmSourceLauncher = () => {
  const [utmSourceLauncher, setUtmSourceLauncher] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=launcher')) {
      setUtmSourceLauncher(true)
      sessionStorage.setItem('utmSourceLauncher', 'true')
    } else {
      const isUtmSourceLauncherFromStorage = sessionStorage.getItem('utmSourceLauncher')

      if (isUtmSourceLauncherFromStorage) {
        setUtmSourceLauncher(isUtmSourceLauncherFromStorage === 'true')
      }
    }
  }, [])

  return { utmSourceLauncher, setUtmSourceLauncher }
}
